interface Props {
  criteria(): boolean;
  callback(): void;
  timeoutSeconds?: number;
}

export const waitForCriteria = ({ criteria, callback, timeoutSeconds = 15 }: Props) => {
  let interval: NodeJS.Timeout | null = null;
  const dateStart = new Date();
  const promise = new Promise<void>((resolve, reject) => {
    interval = setInterval(() => {
      const diffDate = new Date().getTime() - dateStart.getTime();
      if (diffDate / 1000 >= timeoutSeconds) reject();
      if (criteria()) resolve();
    }, 100);
  });

  promise
    .then(() => {
      callback();
    })
    .finally(() => {
      if (interval) clearInterval(interval);
    });
};
